import React from "react";

export default function InstructionCard() {
    return (
        <div style={{display:"flex", justifyContent:"center", alignItems:"center", verticalAlign:"middle"}}>
                  <div className="card">
        <h2 className="card-title">Instructions</h2>
        <ul className="card-list">
          <li>Step 1: Click on Start Button</li>
          <li>Step 2: Scan a QR code</li>
          <li>Step 3: Attach files to it</li>
        </ul>
      </div>
        </div>
    );
}
  